import {Injectable} from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, Observable, of} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import {CreatePrelevementDTO, PrelevementSampleDto, PrelevementSampleView, ReceptionSampleDto, SampleAffectationRequest, SampleDTO, SampleStatus} from "../../customs/_models/sampleDTO";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {error} from "@angular/compiler-cli/src/transformers/util";
import { SampleCountDTO } from '../../customs/_models/SampleCountDTO';
import { ProductData } from '../../customs/_models/typeSampleDTO';
import { PrelevementSampleDTO,ReceptionSampleDTO,ValidateSampleDTO } from '../../customs/_models/SampDto';

interface TaskType {
    id: number;
    label: string;
  }
  
export interface SampleAnalyseResponseDto {
  sampleAnalyseId: number;

  sampleId: number;
  sampleCode: string;
  status: string;

  typeAnalyseId: number;
  typeAnalyseName: string;

  departementId: number;
  departementName: string;

  clientId?: number | null;
  clientName: string | null;

  batchId?: number | null;
  batchReference?: string | null;

  collectedById?: number | null;
  collectedByUsername?: string | null;

  collectionDate?: string | null;
  qtePre?: number | null;
  priorite?: string | null;

  temperaturePrelevement?: string | null;
  dateProduction?: string | null;
  dateLimiteConsommation?: string | null;

  matriceId?: number | null;
  matriceName?: string | null;

  terrainId?: number | null;
  terrainVarPlante?: string | null;

  designation?: string | null;
  scelle?: boolean | null;
  accredited?: boolean | null;
  preleveParClient?: boolean | null;
  conditionnement?: string | null;

  typeSampleName?: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class SampleService {

    constructor(
        private endpoints: Endpoints,
        private http: HttpClient) {
    }


    public fetchSampleList(){
            return this.http.get<CommonResponse>(`${this.endpoints.sampler_base_endpoint}/sampleByUser`)
        }
    getPrelevementsForConnectedUser() {
    console.log('📡 Appel API : GET /sample-analyses/prelevements');
    return this.http.get<SampleAnalyseResponseDto[]>(
      `${this.endpoints.sampler_base_endpoint}`
    );
  }
      getValidateForConnectedUser() {
    console.log('📡 Appel API : GET /sample-analyses/prelevements');
    return this.http.get<SampleAnalyseResponseDto[]>(
      `${this.endpoints.sampler_base_endpoint}/statusSample/valide`
    );
  }
    public fetchDepartementList(){
            return this.http.get<any>(`${this.endpoints.departemet_base_endpoint}`)
    }
    public fetchSampleTypes() {
          return this.http.get<string[]>(`${this.endpoints.sampler_base_endpoint}/sample-types`);
      }
    public fetchSampleDetailsByClientId(): Observable<CommonResponse> {
        console.log(this.endpoints.sampler_base_endpoint)
        return this.http.get<CommonResponse>(this.endpoints.sampler_base_endpoint);
    }

    public save(sample: SampleDTO): Observable<SampleDTO> {
        return this.http.post<SampleDTO>(this.endpoints.sampler_base_endpoint, sample)
    }

    updateSample(id: number, sample: SampleDTO): Observable<SampleDTO> {
        return this.http.put<SampleDTO>(`${this.endpoints.sampler_base_endpoint}/${id}`, sample);
      }

    affectUserToSamples(request: SampleAffectationRequest): Observable<CommonResponse> {
        return this.http.post<CommonResponse>(`${this.endpoints.sampler_base_endpoint}/samples/affect-user`, request);
    }
    
      

    saveFormExcelFile(samples: SampleDTO[]) {
        return this.http.post<CommonResponse>(`${this.endpoints.sampler_base_endpoint}/save-from-excel-file`, samples)
    }

    getSamplesByBatch(batchId: number): Observable<SampleDTO[]> {
        return this.http.get<SampleDTO[]>(`${this.endpoints.sampler_base_endpoint}/batches/${batchId}/samples`);
      }
      

    getSampleById(id: number): Observable<SampleAnalyseResponseDto> {
        return this.http.get<SampleAnalyseResponseDto>(`${this.endpoints.sampler_base_endpoint}/${id}`);
      }
      generateRapport(payload: { sampleIds: number[], country: string }) {
        const url = `${this.endpoints.rapport_endpoint}/create-download`;
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post<string[]>(url, payload, { headers });
    }
    
    generateDevis(sampleIds: number[]) {
        let url = `${this.endpoints.devis_endpoint}/create-download`;
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        
        return this.http.post(url, sampleIds, { headers, responseType: 'json' });
    }
    
    
    total() {
        return this.http.get<number>(`${this.endpoints.sampler_base_endpoint}/totalSamples`)
    }
    public getTaskTypes(): Observable<TaskType[]> {
        return this.http.get<TaskType[]>(`${this.endpoints.sampler_base_endpoint}/task-types`); // endpoint à adapter
    }

    createFromTextFile(data: SampleData[]) {
        console.log(data)
        return this.http.post<CommonResponse>(this.endpoints.sampler_base_endpoint+'/create-from-txt',data)
    }

    getSampleType(){
        return this.http.get<any>(`${this.endpoints.sampler_base_endpoint}/sampleType`);
    }
  getAllProducts(): Observable<ProductData[]> {
    return this.http.get<ProductData[]>(`${this.endpoints.sampler_base_endpoint}/product`);
  }

    parseFileData(data: string): SampleData[] {
        const sections = data.split('[Sample Header]');
        const sampleDataArray: SampleData[] = [];

        sections.forEach(section => {
            if (section.trim()) {
                const lines = section.trim().split('\n');
                const headerLines = lines.slice(0, 9);
                const resultsStartIndex = lines.findIndex(line => line.includes('[Results]')) + 1;
                const resultsEndIndex = lines.findIndex(line => line.includes('[Internal Standards]'));
                const resultLines = lines.slice(resultsStartIndex, resultsEndIndex);
                const header = this.parseHeader(headerLines);
                const results = this.parseResults(resultLines);
                sampleDataArray.push({header, results});
            }
        });
        return sampleDataArray
    }

    private parseHeader(lines: string[]): SampleHeader {
        const header: any = {};
        lines.forEach(line => {
            const [key, value] = line.split('=');
            header[key.trim()] = value ? value.trim() : '';
        });
        return {
            method: header.Method,
            sampleName: header.SampleName,
            sampleType: header['Sample Type'],
        };
    }

    private parseResults(lines: string[]): Result[] {
        const results: Result[] = [];
        lines.forEach(line => {
            const values = line.split(',').map(v => v.trim());
            if (values.length === 8) {
                results.push({
                    elem: values[0],
                    unit: values[1],
                    avg: isNaN(parseFloat(values[2])) ? 0 : parseFloat(values[2]),
                });
            }
        });
        return results;
    }

    public getSamplesByDay(startDate: string, endDate: string): Observable<any[]> {
        const url = `${this.endpoints.sampler_base_endpoint}/samples-by-day?startDate=${startDate}&endDate=${endDate}`;
        return this.http.get<any[]>(url);
    }


      getChartData(duration: string): Observable<any[]> {
        console.log('Fetching chart data for duration:', duration);
        return this.http.get<any[]>(`${this.endpoints.sampler_base_endpoint}/data?duration=${duration}`).pipe(
          catchError(err => {
            console.error('Error fetching chart data:', err);
            return of([]); // Retourner un tableau vide en cas d'erreur
          })
        );
      }

      getSampleCounts(duration: string): Observable<SampleCountDTO[]> {
        return this.http.get<SampleCountDTO[]>(`${this.endpoints.sampler_base_endpoint}/counts?duration=${duration}`);
      }
      getSamplesByStatus(statut: SampleStatus): Observable<any> {
        return this.http.get<any>(`${this.endpoints.sampler_base_endpoint}/status/${statut}`);
      }
      getSampleStatusCount(): Observable<{ 'Avec OT': number, 'Sans OT': number }> {
        return this.http.get<{ 'Avec OT': number, 'Sans OT': number }>(`${this.endpoints.sampler_base_endpoint}/status`);
      }

      createReport(rapport: any): Observable<CommonResponse> {
        let url = `${this.endpoints.rapport_endpoint}`;
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post<CommonResponse>(url, rapport, {headers});
    }
    
      




  // ==============================
  // PRELEVEMENT
  // ==============================

  createPrelevement(sample: PrelevementSampleDto): Observable<any> {
    return this.http.post(`${this.endpoints.sampler_base_endpoint}/prelevement`, sample);
  }
  public getPrelevementSamples(): Observable<PrelevementSampleDTO[]> {
    return this.http.get<PrelevementSampleDTO[]>(`${this.endpoints.sampler_base_endpoint}/status/PRELEVEMENT`);
  }

  // Modifier un prélèvement
  updatePrelevement(id: number, dto: PrelevementSampleDto): Observable<any> {
    return this.http.put<PrelevementSampleDTO>(`${this.endpoints.sampler_base_endpoint}/samples/${id}`, dto);
  }
  // Supprimer un prélèvement
  public deleteSample(sampleId: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoints.sampler_base_endpoint}/${sampleId}`);
  }

  // ==============================
  // RECEPTION
  // ==============================
  public receiveSample(sampleId: number, receptionData: ReceptionSampleDto): Observable<ReceptionSampleDto> {
    return this.http.put<ReceptionSampleDto>(`${this.endpoints.sampler_base_endpoint}/receive/${sampleId}`, receptionData);
  }

  public getReceptionSamples(): Observable<ReceptionSampleDTO[]> {
    return this.http.get<ReceptionSampleDTO[]>(`${this.endpoints.sampler_base_endpoint}/status/RECEPTION`);
  }

  // Modifier réception
  public updateReception(id: number,sample: ReceptionSampleDTO): Observable<ReceptionSampleDTO> {
    return this.http.put<ReceptionSampleDTO>(`${this.endpoints.sampler_base_endpoint}/reception/${id}`, sample);
  }

  // ==============================
  // VALIDATION
  // ==============================
  public validateSample(sample: any): Observable<any> {
  return this.http.put<any>(`${this.endpoints.sampler_base_endpoint}/validate`, sample);
}

  public getValidSamples(): Observable<SampleDTO[]> {
    return this.http.get<SampleDTO[]>(`${this.endpoints.sampler_base_endpoint}/status/VALIDE`);
  }

  public getRejectedSamples(): Observable<SampleDTO[]> {
    return this.http.get<SampleDTO[]>(`${this.endpoints.sampler_base_endpoint}/status/REJETE`);
  }

}


interface SampleHeader {
    method: string;
    sampleName: string;
    sampleType: string;
}

interface Result {
    elem: string;
    unit: string;
    avg: number;
}

interface SampleData {
    header: SampleHeader;
    results: Result[];
}
